var indentation_default = {
  "indentZero": "GX0-h",
  "indentOne": "_7R2kR",
  "indentTwo": "e810B",
  "indentThree": "GCpzZ",
  "indentFour": "MY-P8",
  "indentFive": "kE4eF",
  "indentSix": "btNkG"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
